import React from "react";
import { Link } from "gatsby";
import Navigation from "../navigation";
import Blocks from "editorjs-blocks-react-renderer";
import { getImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";
import BackgroundImage from "gatsby-background-image";
import ImageRenderer from "../imageRenderer";

const Hero = ({ hero, mainMenu, topMenu }) => {
  let image = getImage(hero.Media?.localFile);

  // Use like this:
  const bgImage = convertToBgImage(image);
  return (
    <div
      className={`bg-center bg-cover bg-no-repeat mb-32 lg:mb-[80px]`}
      // style={backgroundImageStyle}
    >
      <BackgroundImage
        Tag="section"
        // Spread bgImage into BackgroundImage:
        {...bgImage}
        preserveStackingContext
        className="h-screen flex flex-col "
      >
        <Navigation mainMenu={mainMenu} topMenu={topMenu} />
        <div className="max-w-screen-xl xxl:max-w-screen-3xl w-full mx-auto p-4 -mb-[80px] lg:mb-16 self-start	mt-auto lg:mt-24 ">
          <div
            className={`max-w-2xl rounded-xl px-12 pt-6 pb-10 bg-white opacity-80 ${
              hero.ShowPanelLeft ? "mr-auto" : "ml-auto"
            }`}
          >
            <h3 className="sm:text-5xl text-3xl font-poppinsbold tracking-tighter text-teal sm:mb-6 mb-3">
              {hero.Title}
            </h3>
            {hero?.Text?.data?.Text ? (
              <div className="sm:mb-8 mb-4 font-base text-eazaGray">
                <Blocks
                  data={JSON.parse(hero.Text.data.Text)}
                  renderers={{
                    image: ImageRenderer,
                  }}
                />
              </div>
            ) : (
              ""
            )}
            {hero.Button?.ShowButton && (
              <Link
                to={hero.Button.Link}
                className={`bg-none border border-orange rounded-xl px-5 py-2
              }`}
              >
                {hero.Button.Label}
              </Link>
            )}
          </div>
        </div>
      </BackgroundImage>
    </div>
  );
};

export default Hero;
